import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Input } from 'semantic-ui-react'
import { UseForm } from '../Hooks/UseForm';
import { SetBook } from '../Reducers/InicioReducer';

export const MonedaDetallePorcentajes = (params) => {
    //#region hooks
    const { MonedaDetalle } = params;
    const { Item } = MonedaDetalle;
    const _book = `${Item.Clave}_mxn`;
    const inicio = useSelector(state => state.inicio)
    const dispatch = useDispatch()
    //#endregion
    //#region internalState
    const _useForm = UseForm();
    const { Entidad, SetEntidad, OnChange } = _useForm;
    const [internalState, setInternalState] = useState({
        Load: false,
    })
    //#endregion
    //#region useEffects
    useEffect(() => { Load(); }, []);
    useEffect(() => {
        if (Entidad && internalState.Load) {
            dispatch(SetBook(Entidad));
        }
    }, [Entidad])
    //#endregion
    //#region Metodos
    const Load = () => {
        // debugger
        let _libroActual = inicio.Books[_book];
        let _state = { ...Entidad };
        if (!_libroActual) {
            _state = {
                Book: _book,
                Compra: 0,
                Venta: 0
            }
        } else {
            _state = {
                Book: _book,
                Compra: _libroActual.CompraPorcentaje,
                Venta: _libroActual.VentaPorcentaje
            }
        }
        SetEntidad((state) => ({ ..._state }));
        setInternalState((state) => ({ ...state, Load: true }));
    }
    //#endregion

    return (
        <div>
            <Input
                name="Compra"
                icon='tags'
                iconPosition='left'
                label={{ tag: true, content: '% Compra' }}
                labelPosition='right'
                value={Entidad.Compra}
                type="number"
                onChange={OnChange}
                placeholder='Compra'
            />
            <br />
            <Input
                name="Venta"
                icon='tags'
                iconPosition='left'
                label={{ tag: true, content: '% Venta  ' }}
                labelPosition='right'
                placeholder='Venta'
                value={Entidad.Venta}
                onChange={OnChange}
                type="number"
                style={{ paddingTop: "10px" }}
            />


        </div>
    )
}
